import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_ESENCIAL } from '../lib/links';
type CTAButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg';
  href?: string;
  className?: string;
};
export function CTAButton({
  children,
  variant = 'primary',
  size = 'lg',
  href = CHECKOUT_ESENCIAL,
  className = ''
}: CTAButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-full font-semibold tracking-tight transition-all duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-forest/25 active:translate-y-px';
  const sizes = {
    md: 'px-6 py-3 text-sm',
    lg: 'px-7 py-4 text-base sm:text-lg'
  };
  const variants = {
    primary: 'bg-forest text-cream shadow-soft hover:bg-forest-dark hover:shadow-lift',
    secondary: 'bg-clay text-white shadow-soft hover:bg-[#a8522f] hover:shadow-lift'
  };
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-31" data-mp="38q3kkzsjveku">
      <span data-id="element-32" data-mp="1dbje1eq09b3w">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-33" data-mp="1daruj29on3tz" />
    </a>;
}